import React from 'react';
import styled from 'styled-components';
import { isEmpty } from "lodash";
import { useLocation } from 'react-router-dom';
import { Form, Col, Button } from 'react-bootstrap';

export function capitalizeFirstLetter(wordValue) {
    if (wordValue.length > 0) {
        return wordValue.charAt(0).toUpperCase() + wordValue.slice(1);
    }
    return wordValue;
}

export function toCamelCase(str) {
    return str.toLowerCase().split(" ").map((word, index) => {
        if (index === 0) {
            return word;
        } else {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }
    }).join('');
}

export function CharacterCount({ count, maxCount }) {
    const remainingCount = maxCount - count;
    return <p>{remainingCount} characters remaining</p>;
}

// can pass through data to ensure values are inputed
export function validateRecords(data, messages) {
    const errors = {};
    data.forEach((record, index) => {
        Object.keys(record).forEach((fieldName) => {
            if (isEmpty(record[fieldName])) {
                const defaultMessage = `${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is required`;
                errors[`${fieldName}${index}`] = messages?.[fieldName] || defaultMessage;
            }
        });
    });
    return errors;
}

export function getWizardSteps() {
    const wizardSteps = [
        { key: "rightToWork", label: 'Right To Work', number: 1, completed: false },
        { key: "employeePrivacyPolicy", label: 'Employee Privacy Policy', number: 2, completed: false },
        { key: "bankDetails", label: 'Bank Details', number: 3, completed: false },
        { key: "previousEmployment", label: 'Previous Employment', number: 4, completed: false },
        { key: "payslipPassword", label: 'Payslip Password', number: 5, completed: false },
        { key: "workingTimeRegulations", label: 'Working Time Regulations', number: 6, completed: false },
        { key: "keyfob", label: 'Keyfob', number: 7, completed: false },
        { key: "nextToKin", label: 'Next Of Kin', number: 8, completed: false },
        { key: "employeeSavingsScheme", label: 'Employee Savings Scheme', number: 9, completed: false },
    ];
    return wizardSteps;
}



export function ProgressBar({ progress }) {
    const ProgressBar = styled.div`
  height: 15px;
  width: 100%;
  background-color: #c5c5c5;
  margin-bottom: 20px;
 position: relative; /* Add this to position the label */
  background-image: 
    repeating-linear-gradient(
      -45deg, 
      transparent, 
      transparent 1rem,
      #ccc 1rem,
      #ccc 2rem
    );
  background-size: 200% 200%;
    animation: barberpole 25s linear infinite;
}

@keyframes barberpole {
  100% {
    background-position: 100% 100%;
  }
}
`;

    const Progress = styled.div`
  height: 100%;
  background-color: #007bff;
  width: ${({ progress }) => `${progress}%`};
  transition: width 0.3s ease-in-out;
`;

    return (
        <ProgressBar>
            <Progress progress={progress} />
        </ProgressBar>
    );
}



export const loadingStyles = {
    loadingScreen: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.89)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        zIndex: 9999
    },
    loadingSpinner: {
        border: "16px solid #f3f3f3",
        borderTop: "16px solid #3498db",
        borderRadius: "50%",
        width: 120,
        height: 120,
        animation: "spin 2s linear infinite"
    },
    loadingText: {
        marginTop: 20,
        fontSize: 20,
        color: "#fff"
    },
    "@keyframes spin": {
        "0%": {
            transform: "rotate(0deg)"
        },
        "100%": {
            transform: "rotate(360deg)"
        }
    }
};

export const getProgress = (curerntStep) => {
    const totalSteps = 9;
    const progressPerStep = 100 / totalSteps;

    switch (curerntStep) {
        case 1:
            return progressPerStep;
        case 2:
            return progressPerStep * 2;
        case 3:
            return progressPerStep * 3;
        case 4:
            return progressPerStep * 4;
        case 5:
            return progressPerStep * 5;
        case 6:
            return progressPerStep * 6;
        case 7:
            return progressPerStep * 7;
        case 8:
            return progressPerStep * 8;
        case 9:
            return progressPerStep * 9;
        default:
            return 0;
    }
};

export const useQuery = () => {
    const searchParams = new URLSearchParams(useLocation().search);
    const employeeId = searchParams.get('employeeId');
    const pin = searchParams.get('pin');
    const inductionId = searchParams.get('inductionId') || 1;
    const lastCompletedStep = searchParams.get('lastCompletedStep') || 1;
    return { employeeId, pin, inductionId, lastCompletedStep };
}

export const FileUploadField = ({ label, name, documentFilename, handleFileUpload, handleRemoveFile, error, disabled = false }) => {
    return (
        <Col className="my-1" xl={12} lg={6} md={6}>
            {label && <h5 className="title">
                {label}
                <span className="star">*</span>
            </h5>}
            <Form.Group>
                <div className={`file-upload-container ${disabled === true && 'file-upload-container-disabled'}`}>
                    <label htmlFor={`file-upload-${name}`} className="file-upload-label">
                        <i className="fas fa-cloud-upload-alt file-upload-icon"></i>
                        {documentFilename ? (
                            <>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    {documentFilename}
                                    <Button onClick={() => handleRemoveFile(name)} style={{ marginLeft: '-8px' }} className="btn-link btn-xs" href="#pablo" variant="danger">
                                        <i className="fas fa-times" style={{ fontSize: '16px', color: '#b83333' }} aria-hidden="true"></i>
                                    </Button>
                                </span>
                            </>
                        ) : (
                            'Click Here To Upload File'
                        )}
                        <p>Files Supported: PDF, DOC, DOCX.</p>
                    </label>
                    <input
                        name={name}
                        id={`file-upload-${name}`}
                        type="file"
                        accept=".pdf, .doc, .docx"
                        onChange={handleFileUpload}
                        className="file-upload-input"
                        disabled={disabled}
                    />
                </div>
            </Form.Group>
            {error && <Form.Text className="text-danger"> <span className="star">*</span> {error} </Form.Text>}
        </Col>
    );
};